import { Controller } from "@hotwired/stimulus"
import SlimSelect from 'slim-select'

// Connects to data-controller="slim"
export default class extends Controller {

  // set slim settings when attaching the data controller like
  // data: {
  //   controller: 'slim',
  //   slim_placeholder_value: 'Select Client!',
  //   slim_show_search_value: true } } %>

  static values = {
    cssClasses: String,
    alwaysOpen: { type: Boolean, default: false },
    contentLocation: String, // use like `document.getElementById(contentLocation)` where contentLocation is an id passed in
    contentPosition: String, // 'absolute', 'relative' or 'fixed'
    openPosition: String, // 'auto', 'up' or 'down'
    placeholder: String,
    allowDeselect: { type: Boolean, default: true },
    disabled: Boolean,
    keepOrder: { type: Boolean, default: true },
    showSearch: { type: Boolean, default: true },
    focusSearch: { type: Boolean, default: true },
    searchText: String,
    searchPlaceholder: String,
    searchHighlight: { type: Boolean, default: true },
    closeOnSelect: { type: Boolean, default: false },
    showOptionTooltips: Boolean,
    hideSelected: { type: Boolean, default: false },
    maxValuesShown: 7,
    maxValuesMessage: String
  }

  connect() {
    // console.log("alwaysOpen value:", this.alwaysOpenValue);
    // console.log("showSearch value:", this.showSearchValue);

    // Add a small delay to ensure DOM is fully ready, especially in modals/turbo frames
    setTimeout(() => {
      // Resolve contentLocation from element ID string to actual HTMLElement
      let contentLocationEl = this.contentLocationValue
        ? document.getElementById(this.contentLocationValue)
        : undefined

      // Guard against portaling into a closed <dialog> (#3037). Slim's
      // floating dropdown renders inside contentLocationEl -- if that's a
      // <dialog> that isn't currently open (e.g. its containing turbo frame
      // was hit via a direct URL rather than the JS modal-open flow), the
      // dropdown is present in the DOM but invisible, since closed <dialog>
      // elements are `display: none` per the UA stylesheet. Fall back to
      // SlimSelect's own default (document.body, always visible) instead.
      if (contentLocationEl instanceof HTMLDialogElement && !contentLocationEl.open) {
        contentLocationEl = undefined
      }

      this.select = new SlimSelect({
        select: this.element,
        settings: {
          placeholderText:    this.placeholderValue,
          cssClasses:         this.cssClassesValue,
          alwaysOpen:         this.alwaysOpenValue,
          contentLocation:    contentLocationEl,
          contentPosition:    this.contentPositionValue,
          openPosition:       this.openPositionValue,
          placeholder:        this.placeholderValue,
          allowDeselect:      this.allowDeselectValue,
          disabled:           this.disabledValue,
          keepOrder:          this.keepOrderValue,
          showSearch:         this.showSearchValue,
          focusSearch:        this.focusSearchValue,
          searchText:         this.searchTextValue,
          searchPlaceholder:  this.searchPlaceholderValue,
          searchHighlight:    this.searchHighlightValue,
          closeOnSelect:      this.closeOnSelectValue,
          showOptionTooltips: this.showOptionTooltipsValue,
          hideSelected:       this.hideSelectedValue,
          maxValuesShown:     this.maxValuesShownValue,
          maxValuesMessage:   this.maxValuesMessageValue
        }
      })
    }, 100) // 100ms delay to ensure DOM is ready
  }

  clear() {
    // setSelected("") picks the blank/placeholder option and re-renders Slim's UI;
    // fall back to the native value if Slim hasn't initialised yet (connect delays 100ms).
    if (this.select) this.select.setSelected("")
    else this.element.value = ""
  }

  submit() {
    // Debounce form submission so multi-select users can pick several
    // options without triggering a submit on every single change
    if (this.submitTimeout) clearTimeout(this.submitTimeout)
    this.submitTimeout = setTimeout(() => {
      this.element.form && this.element.form.requestSubmit()
    }, 800)
  }

  disconnect() {
    if (this.submitTimeout) clearTimeout(this.submitTimeout)
    if (this.select) {
      this.select.destroy()
    }
  }
}
